<template>
  <div class="privacy" v-bind:style="{ paddingBottom: '96px' }">

    <NavigationBar>
      <template v-slot:left>
        <div v-if="canGoBack()">
          <img class="back" src="../assets/icons/ic_16_back.svg" v-on:click="goBack">
        </div>
        <div v-else>
        </div>
      </template>
      <template v-slot:center>
        {{ $t('home.footer_accessibility') }}
      </template>
    </NavigationBar>

    <div v-if="userlang === 'de'">

      <div style="margin-top: 48px;">

        <div id="paragraph_1">
          <h3>Barrierefreiheitserklärung für Teamtip</h3>
          <p>
            Die Betreiber dieser Anwendung sind bemüht, Teamtip im Einklang mit den nationalen Vorschriften zur Barrierefreiheit digitaler Angebote (insbesondere dem Behindertengleichstellungsgesetz – BGG sowie der Barrierefreie-Informationstechnik-Verordnung – BITV 2.0) barrierefrei zugänglich zu machen.
          </p>
        </div>

        <div id="paragraph_2">
          <h3>Stand der Vereinbarkeit mit den Anforderungen</h3>
          <p>
            Diese Anwendung ist <b>teilweise</b> mit den Anforderungen der BITV 2.0 vereinbar. Wir arbeiten kontinuierlich daran, die Zugänglichkeit weiter zu verbessern.
          </p>
        </div>

        <div id="paragraph_3">
          <h3>Nicht barrierefreie Inhalte</h3>
          <h6>Die nachfolgenden Inhalte sind derzeit noch nicht barrierefrei:</h6>
          <div style="margin-left: 20px; margin-bottom: 0px; margin-top: 0px;">
            <p>1.	Einzelne Bedienelemente sind für Screenreader nicht korrekt ausgezeichnet.</p>
            <p>2.	Farbkontraste entsprechen teilweise nicht den Mindestanforderungen.</p>
            <p>3.	Texte und Bedienelemente sind nicht immer per Tastatur bedienbar.</p>
            <p>4.	Videos oder eingebundene Inhalte enthalten keine Untertitel bzw. Transkripte.</p>
          </div>
        </div>

        <div id="paragraph_4">
          <h3>Erstellung dieser Erklärung</h3>
          <p>
            Diese Erklärung wurde am 10. Juni 2025 erstellt. Die Bewertung basiert auf einer Selbstbewertung nach BITV/WCAG-Richtlinien.
          </p>
        </div>

        <div id="paragraph_5">
          <h3>Feedback und Kontakt</h3>
          <p>
            Wenn Sie auf Barrieren stoßen oder Verbesserungsvorschläge haben, kontaktieren Sie uns bitte unter:
          </p>
          <ul>
            <li>E-Mail: <a href="mailto:kontakt@teamtip.net">kontakt@teamtip.net</a></li>
            <li>Betreff: Barrierefreiheit</li>
            <li>Postanschrift: SPM Sportplatz-Media GmbH, Schleidenstraße 3, 22083 Hamburg</li>
          </ul>
        </div>

        <div id="paragraph_6">
          <h3>Durchsetzungsverfahren</h3>
          <p>
            Sollten Sie keine zufriedenstellende Antwort auf Ihre Hinweise zur Barrierefreiheit erhalten, können Sie sich an die Schlichtungsstelle wenden:
          </p>
          <p>
            Schlichtungsstelle BGG<br>
            Bundesbeauftragter für die Belange von Menschen mit Behinderungen<br>
            Mauerstraße 53, 10117 Berlin<br>
            E-Mail: <a href="mailto:info@schlichtungsstelle-bgg.de">info@schlichtungsstelle-bgg.de</a><br>
            Webseite: <a href="https://www.schlichtungsstelle-bgg.de">https://www.schlichtungsstelle-bgg.de</a><br>
          </p>
        </div>
        
        </div>

    </div>

    <div v-else>

      <div style="margin-top: 48px;">

        <div id="paragraph_1">
          <h3>Declaration of accessibility for Teamtip</h3>
          <p>
            The operators of this application endeavor to make Teamtip accessible in accordance with the national regulations on the accessibility of digital services (in particular the Disability Equality Act - BGG and the Barrier-free Information Technology Ordinance - BITV 2.0).
          </p>
        </div>

        <div id="paragraph_2">
          <h3>Status of compatibility with the requirements</h3>
          <p>
            This application is partially compatible with the requirements of BITV 2.0. We are continuously working to further improve accessibility.
          </p>
        </div>

        <div id="paragraph_3">
          <h3>Non-accessible content</h3>
          <h6>The following content is currently not yet accessible:</h6>
          <div style="margin-left: 20px; margin-bottom: 0px; margin-top: 0px;">
            <p>1.	Individual controls are not correctly labeled for screen readers.</p>
            <p>2.	Some color contrasts do not meet the minimum requirements.</p>
            <p>3.	Texts and control elements cannot always be operated using the keyboard.</p>
            <p>4.	Videos or embedded content do not contain subtitles or transcripts.</p>
          </div>
        </div>

        <div id="paragraph_4">
          <h3>Preparation of this declaration</h3>
          <p>
            This declaration was prepared on June 10, 2025. The evaluation is based on a self-assessment according to BITV/WCAG guidelines.
          </p>
        </div>

        <div id="paragraph_5">
          <h3>Feedback and contact</h3>
          <p>
            If you encounter barriers or have suggestions for improvement, please contact us at
          </p>
          <ul>
            <li>Email: <a href="mailto:kontakt@teamtip.net">kontakt@teamtip.net</a> </li>
            <li>Subject: Accessibility</li>
            <li>Postal address: SPM Sportplatz-Media GmbH, Schleidenstraße 3, 22083 Hamburg</li>
          </ul>
        </div>

        <div id="paragraph_6">
          <h3>Enforcement procedure</h3>
          <p>
            If you do not receive a satisfactory response to your information on accessibility, you can contact the conciliation body:
          </p>
          <p>
            Schlichtungsstelle BGG<br>
            Federal Commissioner for Matters relating to Persons with Disabilities<br>
            Mauerstraße 53, 10117 Berlin<br>
            Email: <a href="mailto:info@schlichtungsstelle-bgg.de">info@schlichtungsstelle-bgg.de</a><br>
            Website: <a href="https://www.schlichtungsstelle-bgg.de">https://www.schlichtungsstelle-bgg.de</a><br>
          </p>
        </div>

      </div>
      
    </div>

  </div>
</template>

<script>
import NavigationBar from '../components/NavigationBar'

export default {
  name: 'BetgamePrivacy',
  components: { NavigationBar },
  computed: {
    userlang() {
      return this.$store.state.language
    }
  },
  methods: {
    goBack () {
      if (this.$store.getters.loggedIn) {
        this.$router.push({ name: 'profile' }).catch(err => {})
      } else {
        this.$router.go(-1)
      }
    },
    canGoBack () {
      return window.history && window.history.length > 1
    }
  }
}

</script>

<style lang="scss" scoped>
.privacy {
  h1 {
    font-weight: 600;
    font-size: 1.3em;
    color: black;
  }
  h3 {
    font-weight: 500;
    font-size: 1.2em;
  }
  h5 {
    font-weight: 300;
    font-size: 1.1em;
  }
  h6 {
    font-weight: 200;
    font-size: 1.0em;
    margin-block-start: 1.33em;
    margin-block-end: 1.33em;
  }
  p {
    margin-top: 10px;
    margin-bottom: 10px;
    font-weight: 100;
    font-size: 0.9em;
  }
  a {
    word-break: break-word;
  }
  ul > li {
    font-weight: 100;
    font-size: 0.9em;
    color: #5F5D61;
  }
}
</style>
